module.exports = __webpack_public_path__ + "assets/385be08ce2cff17aa505af11237924f1.png";